import { Component } from '@angular/core';
import { Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-document-lma-card-skeleton',
  imports: [Skeleton],
  templateUrl: './document-lma-card-skeleton.html',
})
export class DocumentLmaCardSkeleton {}
